// src/i18n/languageStore.js
import { getActiveLanguages } from "./translationsLoader";

const LANG_KEY = "gt24_lang";
const SUPPORTED = ["de", "en", "tr", "uk", "pl"]; // Fallback, falls DB-Bundle noch nicht geladen
const DEFAULT_LANG = "de";

// Erlaubt neue, per Übersetzungs-Editor angelegte Sprachen (z.B. "fr"), sobald
// das DB-Bundle geladen ist — vorher gilt die statische Fallback-Liste, damit
// beim allerersten Seitenaufruf (bevor das Bundle da ist) nichts bricht.
function isSupported(lang) {
  const dynamic = getActiveLanguages();
  if (dynamic && dynamic.length > 0) return dynamic.includes(lang);
  return SUPPORTED.includes(lang);
}

// Kunden-Widget (/widget?lang=en | lang=auto): Sprache kommt aus der Adresse, nicht aus dem Speicher des Besuchers
function widgetLangFromUrl() {
  try {
    if (window.location.pathname !== "/widget") return null;
    let l = new URLSearchParams(window.location.search).get("lang");
    if (!l) return null;
    if (l === "auto") l = String(navigator.language || "").slice(0, 2).toLowerCase();
    l = String(l).toLowerCase();
    return /^[a-z]{2}$/.test(l) ? l : null;
  } catch { return null; }
}
const widgetLang = widgetLangFromUrl();

// Übergabe vom Widget an die Angebotsseite (/offers/…?lang=en): Sprache übernehmen und merken
function offersLangFromUrl() {
  try {
    if (!window.location.pathname.startsWith("/offers/")) return null;
    const l = String(new URLSearchParams(window.location.search).get("lang") || "").toLowerCase();
    if (!/^[a-z]{2}$/.test(l)) return null;
    localStorage.setItem(LANG_KEY, l);
    return l;
  } catch { return null; }
}
const offersLang = offersLangFromUrl();

let currentLang = widgetLang || offersLang || localStorage.getItem(LANG_KEY);
if (!widgetLang && !isSupported(currentLang)) currentLang = DEFAULT_LANG;
if (widgetLang && !SUPPORTED.includes(widgetLang) && !isSupported(widgetLang)) currentLang = DEFAULT_LANG;

export const getLanguage = () => currentLang;

export const setLanguage = (lang) => {
  if (!isSupported(lang) || lang === currentLang) return;
  localStorage.setItem(LANG_KEY, lang);
  window.location.reload();
};
export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "/images/symbols/flag-germany.svg" },
  { code: "en", label: "English", flag: "/images/symbols/gb-ukm.svg" },
  { code: "tr", label: "Türkçe", flag: "/images/symbols/flag-turkiye.svg" },
  { code: "uk", label: "українська", flag: "/images/symbols/flag-ukraine.svg" },
  { code: "pl", label: "Polska", flag: "/images/symbols/flag-poland.svg" },
];